import React, {useState} from "react";
import {PlusOutlined} from "@ant-design/icons";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {ActionButtonsContainer} from "./ActionButtons.styles";
import {CustomButton} from "../../../_defaultComponents/CustomButton/CustomButton";
import {Button, Tooltip} from "antd";
import {CreateEquipmentTypeModal} from "../modals/createEquipmentTypeModal/CreateEquipmentTypeModal";

const ActionButtons = ({recall = () => {}}) => {
    const {t} = useTranslation(["pools"]);
    const history = useHistory();
    const [showCreateEquipmentTypeModal, setShowCreateEquipmentTypeModal] = useState(false);

    const openCreateEquipmentTypeModal = () => {
        setShowCreateEquipmentTypeModal(true);
    };
    const closeCreateEquipmentTypeModal = () => {
        setShowCreateEquipmentTypeModal(false);
    };

    return (
        <>
            <ActionButtonsContainer>
                <Tooltip title={"Ekipmanları Görüntüle"}>
                    <Button
                        type="ghost"
                        data-testid="link"
                        onClick={() => history.push("/equipments")}
                    >
                        {"Ekipmanlar"}
                    </Button>
                </Tooltip>
                <Tooltip title={"Yeni Ekipman Tipi Oluştur"}>
                    <CustomButton
                        type="primary"
                        data-testid="createNew"
                        onClick={openCreateEquipmentTypeModal}
                        icon={<PlusOutlined />}
                    >
                        {"Yeni Ekipman Tipi Oluştur"}
                    </CustomButton>
                </Tooltip>
            </ActionButtonsContainer>

            {/* Modals */}
            <CreateEquipmentTypeModal
                visibility={showCreateEquipmentTypeModal}
                recall={recall}
                changeVisibility={setShowCreateEquipmentTypeModal}
                onCancel={closeCreateEquipmentTypeModal}
                onOk={closeCreateEquipmentTypeModal}
            />
        </>
    );
};

export default ActionButtons;
